import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "../features/common/headerSlice";

import { currentUserApi } from "../features/common/userSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import { loggedInBrandApi } from "../features/common/loggedInBrandSlice";
import { branchesApi } from "../features/common/branchesSlice";
import { likedCommentsApi } from "../features/profile/hooks/useGetLikedComments";

const store = configureStore({
  reducer: {
    header: headerSlice,
    [currentUserApi.reducerPath]: currentUserApi.reducer,
    [loggedInBrandApi.reducerPath]: loggedInBrandApi.reducer,
    [branchesApi.reducerPath]: branchesApi.reducer,
    [likedCommentsApi.reducerPath]: likedCommentsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(currentUserApi.middleware)
      .concat(loggedInBrandApi.middleware)
      .concat(branchesApi.middleware)
      .concat(likedCommentsApi.middleware),
});

setupListeners(store.dispatch);

export default store;
